import Divider from 'semantic-ui-react/dist/es/elements/Divider';
import './Divider.css';

export default Divider;
